import type {
  ComponentType,
  CSSProperties,
  HTMLAttributes,
  ReactElement} from 'react';
import {
  createElement,
  memo
} from 'react';

import classNames from 'classnames';

import type { DataQaInterface } from '@utilities/helpers/types';

import styles from './Amount.module.scss';

interface AmountProps extends DataQaInterface {
  size?: 'medium' | 'large';
  icon?: ComponentType<HTMLAttributes<SVGElement>>;
  color?: string;
  value?: string | ReactElement;
  measure?: string;
  skeleton?: 'auto' | 'on' | 'off';
}

const Amount = memo(
  ({ size = 'medium', icon, color, value, measure, skeleton = 'auto', dataQa }: AmountProps) => {
    return (
      <span
        className={classNames(styles['container'])}
        data-size={size}
        data-skeleton-mode={skeleton}
        data-qa={dataQa}
      >
        {!!icon &&
          createElement(icon, {
            className: classNames(styles['icon'], styles['container__icon']),
            style: { '--amount-icon-color': color } as CSSProperties,
          })}

        <span className={classNames(styles['value'])}>{value}</span>

        {!!measure && !!value && <span className={styles['measure']}>{measure}</span>}
      </span>
    );
  },
);

export { Amount, type AmountProps };
